export const evenStyles = {
    left: '50%',
    textAlign: 'left',
    transform: 'translateX(10px)',
    "@media (max-width: 768px)": {
        left: '-18px',
        textAlign: 'left',
        transform: 'translateX(10px)',
    },
};

export const oddStyles = {
    left: '0',
    textAlign: 'left',
    transform: 'translateX(-10px)',
    "@media (max-width: 768px)": {
        // left: '-18px',
        textAlign: 'left',
        transform: 'translateX(10px)',
    },
};

export const circleEvenStyles = {
    // right: 'auto',
    left: '-20px',
};

export const circleOddStyles = {
    left: 'calc(100%)',
    "@media (max-width: 768px)": {
        // left: '-18px',
        left: '-20px'
    },
};

export const lineStyle = (lineHeight) => ({
    // left: '20px',
    position: "absolute",
    top: `70px`,
    left: "calc(50% + 7px)",
    width: "4px",
    backgroundColor: "#29362d", // Line color
    height: `${lineHeight}px`,
    "@media (max-width: 768px)": {
        // left: '-18px',
        left: 'calc(5% + 7px)'
    },
});

export const dayContainerStyle = {
    backgroundColor: '#29362d',
    padding: '25px',
    pl:{
        xs:'20px',
        md:'40px'
    },
    marginRight: '20px',
    marginLeft: '20px',
    // borderRadius: '8px',
    position: 'relative',
    // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    boxShadow: '0',
};
export const dayTittleTextStyle = {
    margin: '0 0 10px',
    color: '#ffffff',
    fontWeight: "bold",
    fontSize: '30px',
    fontFamily: 'Jost-Regular',
};
export const dayActivitiesTextStyle = {
    fontSize: '22px',
    fontFamily: 'Jost-Regular',
};
export const dayActivitiesUlStyle = {
    listStyle: 'none',
    padding: '0',
    margin: '0',
};
export const dayActivitiesLiStyle = {
    margin: '5px 0',
    fontSize: '20px',
    lineHeight: '1.5',
    color: '#ffffff',
};


export const containerStyle = (lineHeight) => ({
    position: 'relative',
    // left: '20px',
    // top: `-${lineHeight}px`,
    width: '80%',
    maxWidth: '900px',
    margin: '0 auto',
    padding: '20px 20px 20px 0px',
    // height: '20%',
    height: 'auto',
    "@media (max-width: 768px)": {
        // left: '-18px',
        width: '90%',
    },
});

export const circleStyle = (index) => ({
    width: "18px",
    height: "18px",
    backgroundColor: "#29362d", // Circle color
    borderRadius: "50%",
    flexShrink: 0,
    position: 'relative',
    top: '20px',
    zIndex: 2,
    ...(index % 2 === 0 ? circleEvenStyles : circleOddStyles),
});

export const dayItemStyle = (index) => ({
    position: 'relative',
    margin: '30px 0',
    width: '50%',
    textAlign: 'left',
    left: '0',
    transform: 'none',
    marginLeft: '20px',
    ...(index % 2 === 0 ? evenStyles : oddStyles),
    "@media (max-width: 768px)": {
        width: '100%',
        textAlign: 'left',
        left: '0',
        transform: 'none',
        marginLeft: '20px',
    },
});
